// Modals used only by the kitchen-customer screen.
// Each of these modals should be registered in src/kitchenCustomer/vue/kitchenCustomerVueInit.js
// And the source for each modal should be in src/kitchenCustomer/vue/modals
const MODAL_NAMES__KITCHEN_CUSTOMER = {
    KITCHEN_CUSTOMER_MENU: 'KitchenCustomerMenuModal',
};

module.exports = {
    MODAL_NAMES__KITCHEN_CUSTOMER,
};
